var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleta({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "111.25391pt",
    height: "18.015625pt",
    viewBox: "0 0 111.25391 18.015625",
    id: "svg312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g312",
    transform: "translate(-35.574219,-395.69141)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#e8e8e8",
    stroke: "#666666",
    strokeWidth: 0.5,
    x: 36,
    y: 396.5,
    width: 108,
    height: 15,
    rx: 1,
    ry: 1,
    id: "main-body"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d0d0d0",
    stroke: "#666666",
    strokeWidth: 0.3,
    x: 37,
    y: 397,
    width: 8,
    height: 14,
    rx: 0.5,
    ry: 0.5,
    id: "left-mechanism"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#d0d0d0",
    stroke: "#666666",
    strokeWidth: 0.3,
    x: 135,
    y: 397,
    width: 6,
    height: 14,
    rx: 0.5,
    ry: 0.5,
    id: "right-handle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "blades"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 48,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 52,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 56,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 60,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 64,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 68,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 72,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 76,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 80,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 84,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 88,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 92,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 96,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 100,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 104,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 108,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 112,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 116,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 120,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 124,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f0f0f0",
    stroke: "#999999",
    strokeWidth: 0.2,
    x: 128,
    y: 398,
    width: 2,
    height: 12,
    rx: 0.2,
    ry: 0.2
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#c0c0c0",
    stroke: "#888888",
    strokeWidth: 0.2,
    x: 36,
    y: 396.2,
    width: 108,
    height: 1,
    id: "top-guide"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c0c0c0",
    stroke: "#888888",
    strokeWidth: 0.2,
    x: 36,
    y: 410.3,
    width: 108,
    height: 1,
    id: "bottom-guide"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "#cccccc",
    strokeWidth: 0.3,
    x: 36,
    y: 396.5,
    width: 108,
    height: 15,
    rx: 1,
    ry: 1,
    id: "shadow"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleta);
export default __webpack_public_path__ + "static/media/roleta.bbe062fa32d2c1a3e85bc76d57b8ba51.svg";
export { ForwardRef as ReactComponent };